/** Exception messages are free text built from whatever was in scope when the
 * code threw: a backend error body, a request URL, an address typed into a
 * form. These patterns cover the credentials and identifiers that have shown
 * up in such messages, so they are redacted before an event leaves the page. */
const SECRET_PATTERNS: ReadonlyArray<[RegExp, string]> = [
  [/\bBearer\s+[A-Za-z0-9._~+/=-]+/gi, 'Bearer [redacted]'],
  [/\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g, '[jwt]'],
  [/\b(?:sk|ak|arm|phx)_(?:live|test)_[A-Za-z0-9_-]+/g, '[api_key]'],
  [/\b(?:sk-|ghp_|gho_|github_pat_|xox[abpr]-)[A-Za-z0-9_-]{8,}/g, '[api_key]'],
  [/([?&#][a-z_-]*(?:token|code|key|secret|password|otp|signature)=)[^&#\s"']+/gi, '$1[redacted]'],
  [/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, '[email]'],
];

export function redactSecrets(text: string): string {
  let out = text;
  for (const [pattern, replacement] of SECRET_PATTERNS) {
    out = out.replace(pattern, replacement);
  }
  return out;
}

/** Walks arrays as well as objects: `$exception_list` is an array of
 * exceptions, each holding a message and an array of stack frames. */
export function redactDeep<T>(value: T): T {
  if (typeof value === 'string') return redactSecrets(value) as T;
  if (Array.isArray(value)) return value.map(redactDeep) as T;
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [key, inner] of Object.entries(value)) out[key] = redactDeep(inner);
    return out as T;
  }
  return value;
}
